export default __webpack_public_path__ + "static/media/25.0d10a970.jpg";